<template>
    <button
        type="button"
        class="ui-copy"
        :title="title"
        :disabled="disabled || !text"
        @click.stop="copyText"
    >
        <span class="material-icons ui-copy__icon">content_copy</span>
    </button>
</template>

<script>
export default {
    name: "CopyComponent",
    props: {
        text: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Copiar",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        async copyText() {
            if (this.disabled || !this.text) return;

            try {
                await navigator.clipboard.writeText(this.text);
                this.$emit("copied", this.text);
            } catch (error) {
                this.$emit("error", error);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.ui-copy {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #9ca3af;
    cursor: pointer;
    transition:
        background-color 0.15s ease,
        color 0.15s ease;
}

.ui-copy:hover:not(:disabled) {
    background: rgba(255, 91, 45, 0.08);
    color: var(--primary-color);
}

.ui-copy:disabled {
    cursor: default;
    opacity: 0.4;
}

.ui-copy__icon {
    font-size: 16px;
}
</style>
